// extracted by mini-css-extract-plugin
export default {"profile_error":"styles_profile_error__OPNOP","profile_error__title":"styles_profile_error__title__UGcuN","profile_error__link":"styles_profile_error__link__yxS7Q"};